<template>
    <div>
        <footer class="main-footer div-home">
            <div class="back-to-top">
                <div>
                    Back
                </div>

            </div>
            <div class="form">
                    <div class="row">
                            <div class="col-12 col-md-12 col-lg-6 right">
                                <h4>Free Workouts &amp; Advice</h4>
                                <p>We send you the latest workouts, videos, expert guides and deals.</p>
                            </div>
                            <div class="col-12 col-md-12 col-lg-6 left aright-self-right align-self-middle">
                                <div class="input-group">
                                        <input class="input-group-field" id="fields_email_footer" type="email" name="fields_email" placeholder="Email Address" title="Please enter your email address" pattern="^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$" required="">
                                        <div class="input-group-button">
                                            <button type="submit" class="button" onclick="window.location.reload();">
                                                Subscribe
                                            </button>
                                        </div>
                                    </div>
                            </div>
                    </div>
            </div>
            <div class="container">
                <footer-widgets></footer-widgets>
            </div>
            <!--<footer-copyright></footer-copyright>-->

        </footer>
    </div>
</template>

<script>
    import footerCopyright from './footerCopyright.vue'
    import footerInfo from './footerInfo.vue'
    import footerWidgets from './footerWidgets.vue'
    export default {
        components: {
            'footer-copyright': footerCopyright,
            'footer-info': footerInfo,
            'footer-widgets': footerWidgets
        }
    }
</script>

<style scoped>

    footer.main-footer .back-to-top {
        /*font-size: 20px;
        margin-bottom: unset;*/
        color: #fff;
    }

    .container {
    }
    .form {
        width: 100%;
        margin-bottom: 20px;
        text-align: center;
        background-color: #0687e6 !important;
    }
        .form .row {
            max-width: 90%;
            margin: 0 auto;
            background-color: #0687e6 !important;
        }
        .form .row h4, .form .row p{
            color: #fff;
        }
    .input-group {
        display: flex;
        width: 100%;
        margin-bottom: .8888888889rem;
        align-items: stretch;
    }
    .input-group-button {
        padding-top: 0;
        padding-bottom: 0;
        text-align: center;
        display: flex;
        flex: 0 0 auto;
        width: 18%;
        margin-left: 2%;
        margin-top: 45px;
        height: 40px;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 17px;
        padding: 8px 35px;
    }
    [type="color"], [type="date"], [type="email"], [type="number"], [type="password"], [type="search"], [type="text"], [type="time"], [type="url"], [type="week"] {
        display: block;
        box-sizing: border-box;
        width: 80%;
        height: 2.3333333333rem;
        margin: 0 0 .8888888889rem;
        padding: .4444444444rem;
        border: 1px solid #e6e7e8;
        border-radius: 2px;
        background-color: #fefefe;
        box-shadow: none;
        font-family: inherit;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #0a0a0a;
        transition: box-shadow .5s,border-color .25s ease-in-out;
        -webkit-appearance: none;
        float: left;
        margin-top: 45px;
    }
    .input-group-button a, .input-group-button button, .input-group-button input, .input-group-button label {
        align-self: stretch;
        height: auto;
        padding-top: 0;
        padding-bottom: 0;
        font-size: 1rem;
    }
    .button, .button.disabled, .button.disabled:focus, .button.disabled:hover, .button[disabled], .button[disabled]:focus, .button[disabled]:hover {
        background-color: #059;
        color: #fefefe;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .input-group-field {
            width: 100%;
            margin-top: 0px !important;
        }
        .input-group-button {
            width: 100%;
            margin-left: 0px !important;
            margin-top: 0px !important;
            margin-top: 0px !important;
        }
    }
    @media only screen and (min-width: 641px) and (max-width: 992px) {
        .input-group-field {
            width: 100%;
            margin-top: 45px !important;
        }

        .input-group-button {
            width: 100%;
            margin-left: 0px !important;
            margin-top: 0px !important;
        }
    }
</style>